// Navigacijos programa — vartotojo pasirinkta pagrindinė (Google Maps / Waze / Apple Maps).
// Įsimenam localStorage; „Kelias iki čia" veda tiesiai į ją. Keisti — palaikius mygtuką.

const RAKTAS = 'navigacija'

export const NAVIGACIJOS = [
  { id: 'google', pavadinimas: 'Google Maps', ikona: 'map' },
  { id: 'waze', pavadinimas: 'Waze', ikona: 'waze' },
  { id: 'apple', pavadinimas: 'Apple Maps', ikona: 'apple' },
]

export function getNavigacija() {
  try {
    const v = localStorage.getItem(RAKTAS)
    return NAVIGACIJOS.some(n => n.id === v) ? v : null
  } catch {
    return null
  }
}

export function setNavigacija(id) {
  try { localStorage.setItem(RAKTAS, id) } catch {}
}

// Ar įrenginys iOS/Mac (kad Apple Maps siūlytume tik ten, kur veikia natūraliai)
export function arApple() {
  if (typeof navigator === 'undefined') return false
  return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent || '')
}

export function navUrl(id, lat, lng) {
  switch (id) {
    case 'waze':
      return `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`
    case 'apple':
      return `https://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`
    case 'google':
    default:
      return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
  }
}

// Atidaro pasirinktą navigaciją į vietą naujame skirtuke.
export function atidarytiNavigacija(id, lat, lng) {
  window.open(navUrl(id, lat, lng), '_blank')
}
